import { OnboardingValidatorSchema } from 'clickNgo/configs/service/onboarding'
import { validateAsync } from 'clickNgo/services/validation'

import { IContact } from '../model/types'

type ValidateContactPayload = Pick<IContact, 'contactId' | 'partnerId' | 'country'> &
  Partial<IContact>

export const validateContact = async (contact: ValidateContactPayload) => {
  const payload = {
    object: contact,
    schemaId: OnboardingValidatorSchema.CG_CONTACT,
  }

  return validateAsync(payload)
}
